import z from 'zod'
import { decimalSchema } from '../../utils/schema'

const balanceSchema = z.object({
  asset: z.string(),
  free: decimalSchema,
  locked: decimalSchema,
})

export const spotAccountSchema = z.object({
  canTrade: z.boolean(),
  canWithdraw: z.boolean(),
  canDeposit: z.boolean(),
  updateTime: z.number().nullable(),
  accountType: z.string(),
  balances: balanceSchema.array(),
})

export const futureAssetSchema = z.object({
  currency: z.string(),
  positionMargin: z.number(),
  availableBalance: z.number(),
  cashBalance: z.number(),
  frozenBalance: z.number(),
  equity: z.number(),
  unrealized: z.number(),
  bonus: z.number(),
})
